/*
* An interface SDK for playtomic (id.net Game API)
*/
define('playtomic',['utils/jssha', 'logger', 'runtime', 'dialogs_manager', 'utils/constants'],
function(jsSHA, Logger, Runtime, DialogManager, CONST) {
  var Playtomic = {
    apiurl: prepareAddress(CONST.playtomic_url),
    appid: null,
    appsession: '',
    loaded: false,
    debug: false,
  
    /**
    * Initializes the API
    * @param appid Your game's public key
    */
    init: function(appid, options, callback) {
      var self = this;
      this.appid = appid;
      if(this.loaded){
        if(this.debug){
          Logger.log('Game API already initialized');
        }
        return;
      }
      
      var initComplete = function initComplete(callback, postdata, data, response) {
        if(!callback) {
          return;
        }
    
        if(!response.success) {
          callback(data, response);
          return;
        }
        self.loaded = true;
        self.appsession = data.appsession;
        if(this.debug){
          Logger.log('playtomic init');
        }
        callback(data, response);
      };

      this.sendAPIRequest('init', 'start', initComplete, callback, null);
    },
    Achievements: {
      /**
       * Lists all achievements and show dialog. If player is logged in, it will also return their achievements. 
       */
      list: function(options) {
        if(!options){
          options = {};
        }
        if(Runtime.getOAuthToken()){
          options.playerid = Runtime.getAuthResponse().details.pid;
        }
        Playtomic.requestForwarder('achievements', 'list', displayAchievements, options);
      },

      /**
       * Lists all achievements. If player is logged in, it will also return their achievements
       */
      listCustom: function(options, callback) {
        if(!options){
          options = {};
        }
        if(Runtime.getOAuthToken()){
          options.playerid = Runtime.getAuthResponse().details.pid;
        }
        Playtomic.sendAPIRequest('achievements', 'list', generalComplete, callback, options);
      },

      /**
       * Award an achievement to a player
       */
      save: function(achievement, callback) {
        if(!Runtime.getOAuthToken()){
          if(this.debug){
            Logger.log('user must login before saving an achievement');
          }
          return;
        }
        if(!achievement.hasOwnProperty('playerid')){
          achievement.playerid = Runtime.getAuthResponse().details.pid;
        }
        if(!achievement.hasOwnProperty('playername')){
          achievement.playername = Runtime.getAuthResponse().details.nickname;
        }
        Playtomic.sendAPIRequest('achievements', 'save', generalComplete, callback, achievement);
      }
    },
    Leaderboards: {
      /**
       * List all high score tables for an app
       */
      tables: function(options, callback) {
        Playtomic.sendAPIRequest('leaderboards', 'tables', generalComplete, callback, options);
      },
      /**
       * Lists scores from a table or get a specsific player's score
       */   
      list: function(options) {
        options.page = 1;
        options.perpage = 10;
        Playtomic.requestForwarder('leaderboards', 'list', displayScores, options);
      },
      /*
      * Return scores list to the callback for custom UI.
      */
      listCustom: function(options, callback) {
        Playtomic.sendAPIRequest('leaderboards', 'list', generalComplete, callback, options);
      },
      /**
       * Saves a user's score
       */   
      save: function(score, callback) {
        if(!Runtime.getOAuthToken()){
          if(this.debug){
            Logger.log('user must login before saving an achievement');
          }
          return;
        }
        if(!score.hasOwnProperty('playerid')){
          score.playerid = Runtime.getAuthResponse().details.pid;
        }
        if(!score.hasOwnProperty('playername')){
          score.playername = Runtime.getAuthResponse().details.nickname;
        }
        Playtomic.sendAPIRequest('leaderboards', 'save', generalComplete, callback, score);
      },
    },
    PlayerLevels: {

    },
    Stats: {

    },
    sendAPIRequest: function(section, action, complete, callback, postdata){
      var self = this;
      postdata = postdata || {};
      postdata.section = section;
      postdata.action = action;
      if (!postdata.appid) {
        postdata.appid = this.appid;
        if (section != 'init' && !this.loaded && this.debug) {
          Logger.log('init has yet to be called, trying to send anyway');
        }
      }
    
      var json = JSON.stringify(postdata);
      var shaObj = new jsSHA(json+this.appsession, "TEXT");
      var hash = shaObj.getHash("SHA-256", "HEX");
      hash = hash.substring(0,20);
      var newurl = this.apiurl +'?hash='+hash;
      var pda = json;
      var request = window.XDomainRequest ? new XDomainRequest() : new XMLHttpRequest(); 
    
      request.onerror = function() {
        complete(callback, postdata, {}, Response(false, 1));
      };
      request.onload = function() {
        if(self.debug){
          Logger.log(request.responseText);
        }
        var result = JSON.parse(request.responseText);
        complete(callback, postdata, result, Response(result.success, result.errorcode));
      };
   
      if(window.XDomainRequest) {
        request.open("POST", newurl);
      }else{
        request.open("POST", newurl, true);
      }
      request.send(pda);
    },
    requestForwarder: function(section, action, callback, postdata){
      var self = this;
      postdata = postdata || {};
      postdata.section = section;
      postdata.action = action;
      postdata.appid = this.appid;
    
      var json = JSON.stringify(postdata);
      var shaObj = new jsSHA(json+this.appsession, "TEXT");
      var hash = shaObj.getHash("SHA-256", "HEX");
      hash = hash.substring(0,20);
      var newurl = this.apiurl +'?hash='+hash;

      if(callback){
        callback(hash, json);
      }
    }
  };
  return Playtomic;

  // private functions to do pre-processing before callbacks
  function Response(success, errorcode) {
    return {
      success: success, 
      errorcode: errorcode
    };
  }

  function displayAchievements(hash, query){
    var dialog = DialogManager.open({
      method: 'achievements',
      redirect_uri: Runtime.getRedirectUri(),
      h: hash,
      q: query
    });
  }

  function displayScores(hash, query){
    var scoreq = {
      method: 'advanced_scores',
      redirect_uri: Runtime.getRedirectUri(),
      h: hash,
      q: query,
    };

    if(Runtime.getOAuthToken()){
      scoreq['u'] = Runtime.getAuthResponse().details.pid;
    }

    DialogManager.open(scoreq);
  }

  function generalComplete(callback, postdata, data, response) {
    if(callback){
      callback(data);
    }
  }

  // IE 10 and below give security errors for using https on a http page
  // Consider removing this in the future as IE 10 becomes less popular
  function prepareAddress(address) {
    if (address && window.location.protocol == 'http:' && address.search('https') != -1) {
      address = address.split('https').join('http');
    }
    return address;
  }

});

